import { render, staticRenderFns } from "./UserTestQuestionsAnswer.vue?vue&type=template&id=cbed585a"
import script from "./UserTestQuestionsAnswer.vue?vue&type=script&lang=js"
export * from "./UserTestQuestionsAnswer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports